import React from 'react'
import Link from 'gatsby-link'
import HomeHeader from '../components/headers/home-header.js'
import SectionComponent from '../components/section.js'
import SectionCallComponent from '../components/section-call.js'
import SectionRegisterComponent from '../components/section-register.js'
import SectionProgramComponent from '../components/section-program.js'
import SectionServicesComponent from '../components/section-services.js'
import SectionTourComponent from '../components/section-tour.js'
import SectionProfilesComponent from '../components/section-profiles.js'
import SectionContactComponent from '../components/section-contact.js'
import SectionSponsorComponent from '../components/section-sponsor.js'
import MenuComponent from '../components/burger-menu'

class IndexPage extends React.Component {
  render() {
    const sections = this.props.data.allMarkdownRemark.edges
    // const { sections } = this.props.data.allMarkdownRemark.edges;
    return (
      <div>
        <HomeHeader />
        <div className="sections">
          {sections
            .filter(section => (section.node.frontmatter.title.length > 0 && section.node.frontmatter.id === '1'))
            .map(({ node: section }) => {
              return (
                <SectionComponent section={section} key={section.frontmatter.id} />
              );
            })}
          <SectionCallComponent />
          <SectionRegisterComponent />
          <SectionProgramComponent />
          {sections
            .filter(section => (section.node.frontmatter.title.length > 0 && section.node.frontmatter.type === 'section' && section.node.frontmatter.id !== '1'))
            .map(({ node: section }) => {
              return (
                <SectionComponent section={section} key={section.frontmatter.id} />
              );
            })}
          <SectionServicesComponent />
          <SectionTourComponent />
          <SectionContactComponent />
          <SectionProfilesComponent />
          <SectionSponsorComponent />
        </div>
      </div>
      
        )
  }
}

export default IndexPage

export const IndexQuery = graphql`
query IndexQuery {
          allMarkdownRemark(filter: {frontmatter: {type: {eq:"section"} } }, sort: {order: ASC, fields: [frontmatter___id] }) {
          edges {
        node {
          html
        frontmatter {
          title
          date(formatString: "MMMM DD, YYYY")
          path
          class
          image
          type
          id
          hash
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/pages/index.js